// Apolo IDE — PlanCanvasToolbar (sprint plan-tab-v1, E2).
//
// Pílula glass flutuante no rodapé do canvas. Zoom controls + add block +
// fit-to-view. Inspirado no screenshot do Pedro com 5 controles.

import { Hand, Maximize2, Minus, MousePointer2, Plus, RotateCcw, Sparkles } from 'lucide-react';

const ToolbarBtn = ({ children, label, onClick, active = false }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={label}
    title={label}
    className={`relative inline-flex h-9 w-9 items-center justify-center rounded-md text-apolo-textSecondary transition hover:bg-apolo-surface3 hover:text-apolo-textPrimary focus:outline-none focus-visible:ring-2 focus-visible:ring-apolo-plan-accentRing ${
      active ? 'bg-apolo-plan-accentMuted text-apolo-plan-accent' : ''
    }`}
  >
    {children}
  </button>
);

export default function PlanCanvasToolbar({ zoom, onZoomIn, onZoomOut, onResetZoom, onFit, onAdd, onOpenSkills }) {
  const zoomPct = `${Math.round((zoom ?? 1) * 100)}%`;
  return (
    <div
      role="toolbar"
      aria-label="Controles do canvas"
      className="pointer-events-auto absolute bottom-4 left-1/2 z-30 -translate-x-1/2"
    >
      <div
        className="flex items-center gap-0.5 rounded-full border border-apolo-borderSubtle bg-apolo-surface1/80 px-2 py-1.5 backdrop-blur-md"
        style={{ boxShadow: 'var(--apolo-plan-glow-wide), 0 6px 24px rgba(0,0,0,0.18)' }}
      >
        {/* Selection / hand placeholders pra paridade visual (não funcionais aqui) */}
        <ToolbarBtn label="Selecionar"><MousePointer2 size={16} /></ToolbarBtn>
        <ToolbarBtn label="Mover canvas (hold space)"><Hand size={16} /></ToolbarBtn>

        <span aria-hidden="true" className="mx-1 h-5 w-px bg-apolo-borderSubtle" />

        <ToolbarBtn label="Diminuir zoom" onClick={onZoomOut}><Minus size={16} /></ToolbarBtn>
        <button
          type="button"
          onClick={onResetZoom}
          aria-label="Resetar zoom"
          title="Resetar zoom (⌘0)"
          className="inline-flex h-9 min-w-[52px] items-center justify-center rounded-md px-2 text-xs font-medium text-apolo-textSecondary transition hover:bg-apolo-surface3 hover:text-apolo-textPrimary focus:outline-none focus-visible:ring-2 focus-visible:ring-apolo-plan-accentRing"
        >
          {zoomPct}
        </button>
        <ToolbarBtn label="Aumentar zoom" onClick={onZoomIn}><Plus size={16} /></ToolbarBtn>
        <ToolbarBtn label="Encaixar tudo" onClick={onFit}><Maximize2 size={16} /></ToolbarBtn>

        <span aria-hidden="true" className="mx-1 h-5 w-px bg-apolo-borderSubtle" />

        <button
          type="button"
          onClick={onAdd}
          aria-label="Adicionar bloco"
          title="Adicionar bloco (⌘N)"
          className="inline-flex h-9 items-center gap-1.5 rounded-md px-3 text-xs font-semibold text-white transition hover:brightness-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-apolo-plan-accentRing"
          style={{ background: 'var(--apolo-plan-gradient)', boxShadow: 'var(--apolo-plan-glow-tight)' }}
        >
          <Plus size={14} /> Novo bloco
        </button>

        <ToolbarBtn label="Skills (⌘⇧K)" onClick={onOpenSkills}><Sparkles size={16} /></ToolbarBtn>

        <span aria-hidden="true" className="mx-1 h-5 w-px bg-apolo-borderSubtle" />

        <ToolbarBtn label="Limpar viewport" onClick={onResetZoom}><RotateCcw size={16} /></ToolbarBtn>
      </div>
    </div>
  );
}
